module.exports = __webpack_public_path__ + "media/v2/components/Contests/shared/Image/pendingPick-56aaf4f0aff816bf9a8b41ce266002c5.svg";